import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { Modal } from '@shared/components/modal';
import { useModals } from '@shared/contexts/modal-context';

import { config } from '@/config.ts';

import { ModalName } from '../types';
import { OfferCom2 } from './offer-com2.tsx';
import { OfferJohnny } from './offer-johnny.tsx';
import * as Styled from './offer-rules-modal.styled.ts';
import { Offer } from './offer.tsx';

type OfferComponent = React.ComponentType;

interface BrandOfferConfig {
	component: OfferComponent;
	title: string;
}

const useBrandOfferMap = (brand: string): BrandOfferConfig => {
	const { t } = useTranslation('');

	switch (brand) {
		case 'ngu3':
		case 'johnny':
			return {
				component: OfferJohnny,
				title: 'Правила та умови акції X-Pass:'
			};

		case 'com2':
			return {
				component: OfferCom2,
				title: `${t('condition_rules_vippass')}:`
			};

		default:
			return {
				component: Offer,
				title: ''
			};
	}
};

const OfferRulesModal = () => {
	const { isModalOpen, closeModal } = useModals();
	const { t } = useTranslation('offer');

	const brand = config.BRAND || 'default';
	const offerConfig = useBrandOfferMap(brand);
	const OfferComponent = offerConfig.component;
	const title = offerConfig.title || t('offer_header');

	return (
		<Modal
			isOpen={isModalOpen(ModalName.OFFER_RULES)}
			title={title}
			closeModal={closeModal}
			onBackButtonClick
			backgroundColor='dark'
		>
			<Styled.Wrapper>
				<OfferComponent />
			</Styled.Wrapper>
		</Modal>
	);
};

export default OfferRulesModal;
